/* Registro de service worker + prompt de instalação PWA.
 * Chamado uma vez em index.js. Isolado para poder ser desabilitado em dev.
 */

const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
  window.location.hostname === '[::1]' ||
  window.location.hostname.match(/^127(?:\.\d{1,3}){3}$/)
);

export function registerSW() {
  if (!('serviceWorker' in navigator)) return;
  // Em produção sempre; em dev apenas se explicitamente habilitado
  if (isLocalhost && !window.__AAB_ENABLE_SW__) return;

  window.addEventListener('load', () => {
    const swUrl = '/service-worker.js';
    navigator.serviceWorker
      .register(swUrl)
      .then((reg) => {
        // Detecta nova versão
        reg.onupdatefound = () => {
          const installing = reg.installing;
          if (!installing) return;
          installing.onstatechange = () => {
            if (installing.state === 'installed' && navigator.serviceWorker.controller) {
              // Nova versão pronta — pede skipWaiting silenciosamente
              installing.postMessage({ type: 'SKIP_WAITING' });
            }
          };
        };
      })
      .catch(() => {/* silencioso */});

    // Recarrega a página automaticamente quando um novo SW toma controle
    // (garante que o usuário veja imediatamente a nova versão).
    let refreshing = false;
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (refreshing) return;
      refreshing = true;
      window.location.reload();
    });
  });
}

// Captura beforeinstallprompt para uso pelo componente InstallPWA
let deferredPrompt = null;
const listeners = new Set();

if (typeof window !== 'undefined') {
  window.addEventListener('beforeinstallprompt', (e) => {
    e.preventDefault();
    deferredPrompt = e;
    listeners.forEach((cb) => cb(true));
  });
  window.addEventListener('appinstalled', () => {
    deferredPrompt = null;
    listeners.forEach((cb) => cb(false));
  });
}

export function subscribeInstallable(cb) {
  listeners.add(cb);
  cb(!!deferredPrompt);
  return () => listeners.delete(cb);
}

export async function triggerInstall() {
  if (!deferredPrompt) return { outcome: 'not-available' };
  deferredPrompt.prompt();
  const choice = await deferredPrompt.userChoice;
  deferredPrompt = null;
  listeners.forEach((cb) => cb(false));
  return choice;
}

export function isStandalone() {
  return (
    window.matchMedia('(display-mode: standalone)').matches ||
    // iOS Safari
    window.navigator.standalone === true
  );
}

export function isIOS() {
  return /iphone|ipad|ipod/i.test(window.navigator.userAgent);
}
